export default {
      id: "md_violations-usage",
      viewBox: "0 0 17 15",
      url: __webpack_public_path__ + "img/icons.svg#md_violations",
      toString: function () {
        return this.url;
      }
    }